'use client';

import { Box } from '@mui/material';
import Image from 'next/image';
import { usePageAction } from '@repo/hooks/usePageAction';
import { LinkViewed } from '@repo/segment/Analytics/LinkViewed';
import { SafeLinkWithFallback } from '../../../../../SafeLinkWithFallback';

type Props = {
  reviewLink?: string;
  source?: string;
  alt?: string;
  institution?: {
    id: string;
    name?: string;
  };
  linkPosition?: number;
};

const imageBox = (source: string, alt: string | undefined) => (
  <Box sx={{ maxWidth: { xs: '144px', sm: '127px', md: '127px' } }}>
    <Image
      src={source}
      alt={alt ?? ''}
      width={0}
      height={0}
      sizes="100vw"
      style={{ width: '100%', height: 'auto' }}
    />
  </Box>
);

export const ProductImage = ({ source, alt, reviewLink, institution, linkPosition }: Props) => {
  // TODO: Segment Standardization Cleanup
  const imageClickEvent = usePageAction({
    actionDestinationUrl: reviewLink,
    actionName: 'nw_review_redirected',
    actionSection: 'banking_cd_institution_card',
    actionType: 'select',
    additionalAttributes: {
      institution_id: institution?.id,
      institution_nm: institution?.name,
    },
  });

  if (!source) return null;

  if (!reviewLink) {
    return imageBox(source, alt);
  }

  return (
    <LinkViewed
      entityName="nw_review_redirected"
      sectionName="banking_cd_institution_card"
      destinationUrl={reviewLink}
      linkPosition={linkPosition}
      additionalAttributes={{
        institution_id: institution?.id,
        institution_nm: institution?.name,
      }}
    >
      {({ fireLinkClicked }) => (
        <SafeLinkWithFallback
          href={reviewLink}
          target="_blank"
          onClick={() => {
            imageClickEvent();
            fireLinkClicked();
          }}
        >
          {imageBox(source, alt)}
        </SafeLinkWithFallback>
      )}
    </LinkViewed>
  );
};
